// Canonical contract id -> route slug map. Single source of truth: App.js
// builds CONTRACT_TYPES slugs from here, and analytics call sites resolve back
// through getContractIdFromSlug so `contract_type` always reports the contract
// id ("inchiriere"), never the route slug ("contract-inchiriere").
//
// Slugs are not derivable from ids by rule — most are prefixed with
// "contract-", but "nda", "notificare-reziliere" and "act-aditional-inchiriere"
// are not — so the pairs are listed explicitly.

const CONTRACT_SLUGS = {
  "inchiriere": "contract-inchiriere",
  "act-aditional-inchiriere": "act-aditional-inchiriere",
  "imprumut": "contract-imprumut",
  "vanzare-auto": "contract-vanzare-auto",
  "comodat": "contract-comodat",
  "prestari-servicii": "contract-prestari-servicii",
  "colaborare-pfa": "contract-colaborare-pfa",
  "notificare-reziliere": "notificare-reziliere",
  "nda": "nda",
};

const SLUG_TO_ID = Object.entries(CONTRACT_SLUGS).reduce((acc, [id, slug]) => {
  acc[slug] = id;
  return acc;
}, {});

// Accepts a bare slug or a path ("/contract-inchiriere", with optional query or
// hash). Returns undefined for anything that is not a contract route (e.g. a
// blog link) so callers omit `contract_type` rather than reporting a bad value.
export function getContractIdFromSlug(slug) {
  if (!slug) return undefined;
  const clean = String(slug)
    .split(/[?#]/)[0]
    .replace(/^\//, "")
    .replace(/\/$/, "");
  return SLUG_TO_ID[clean];
}

export default CONTRACT_SLUGS;
